import Vue from 'vue';
import FormApi from '@/api/FormApi';

const api = new FormApi();
const formModule = {
  state: { forms: {}, incompleteForms: {} },

  getters: {
    incompleteForms: (state) => state.incompleteForms,
  },
  mutations: {
    SET_FORM: (state, form) => {
      Vue.set(state.forms, form.id, form);
    },
    SET_INCOMPLETE_FORM: (state, payload) => {
      Vue.set(state.incompleteForms, payload.key, payload.variables);
    },
    SET_INCOMPLETE_FORMS: (state, payload) => {
      Vue.set(state.incompleteForms, payload);
    },
  },
  actions: {
    loadForm: (context, formId) => {
      if (context.state.forms[formId]) {
        return Promise.resolve(context.state.forms[formId]);
      }

      return api.getForm(formId).then((form) => {
        context.commit('SET_FORM', form);
        return form;
      });
    },
    updateIncompleteForm: (context, payload) => {
      context.commit('SET_INCOMPLETE_FORM', payload);
    },
    clearIncompleteForm: (context, key) => {
      context.commit('SET_INCOMPLETE_FORM', { key, variables: undefined });
    },
    clearIncompleteForms: (context) => {
      context.commit('SET_INCOMPLETE_FORMS', []);
    },
  },
};

export default formModule;
